import React, { forwardRef } from "react";
import classNames from "classnames";

interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /**
   * Extend classnames
   */
  extendClasses?: string;
  /**
   * Error state
   */
  error?: boolean;
  /**
   * Size of holder
   */
  size?: number;
  /**
   * Color unchecked
   */
  color?: string;
  /**
   * Color checked
   */
  activeColor?: string;
  /**
   * Content
   */
  children?: React.ReactNode;
}

const RadioRef: React.ForwardRefRenderFunction<HTMLInputElement, RadioProps> = (
  {
    id,
    error,
    children,
    extendClasses,
    size = 16,
    disabled,
    color = "#d9d9d9",
    activeColor = "#f05b28",
    ...props
  },
  ref
) => (
  <label
    htmlFor={id}
    className={classNames({
      tfcRadio: true,
      [`tfcRadio-disabled`]: disabled,
      [`tfcRadio-error`]: error,
      [extendClasses as string]: !!extendClasses,
    })}
  >
    <input
      type="radio"
      ref={ref}
      hidden
      disabled={disabled}
      id={id}
      {...props}
    />
    <span className="tfcRadio-holder">
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        className="tfcRadio-holder-unchecked"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
          fill={error ? "#FF4D4F" : color}
        />
      </svg>

      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        className="tfcRadio-holder-checked"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 5C7.24 5 5 7.24 5 10C5 12.76 7.24 15 10 15C12.76 15 15 12.76 15 10C15 7.24 12.76 5 10 5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
          fill={error ? "#FF4D4F" : disabled ? color : activeColor}
        />
      </svg>
    </span>
    {children}
  </label>
);

const Radio = forwardRef(RadioRef);

export default Radio;
